const comics = [
  { url: require('@/assets/comics/12-01.svg') },
  { url: require('@/assets/comics/13-01.svg') },
  { url: require('@/assets/comics/13-02.svg') },
]

export default {
  name: 'step0',

  setup() {
    return {
      comics,
    }
  },
}
